import React from 'react';

import Data from './Data';

const AltmetricSidebar = (props) => {
  return <Data {...props} />;
};

export default AltmetricSidebar;
